const reducerScheduledServices = {
  completed: 'Completed Services',
  delayed: 'Delayed Services',
  scheduledServices: 'Scheduled Services',
};

export default reducerScheduledServices;
